module.exports = __webpack_public_path__ + "static/media/glass_grey.530ce724.svg";